"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relationMisalignedRule = void 0;
exports.getMisalignedRelation = getMisalignedRelation;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
/**
 * Relations are made to link entities by referencing a target record from a source record, mostly using the primary key.
 * As columns on both side of the relation store the same thing, they should also have the same type.
 * Sometimes, subtle differences (like varchar length) may not be an issue, it's far from ideal and may become one at some point.
 */
const ruleId = 'relation-misaligned-type';
const ruleName = 'misaligned relation';
const ruleDescription = 'relations with different attribute type on each side';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.RelationId.array().optional()
}).strict().describe('RelationMisalignedConf');
exports.relationMisalignedRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.high },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.extra?.relation ? (0, databaseUtils_1.relationToRef)(r.extra?.relation) : undefined).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.relationRefFromId) || []);
        const entities = (0, utils_1.indexBy)(db.entities || [], databaseUtils_1.entityToId);
        return (db.relations || [])
            .map(r => getMisalignedRelation(r, entities))
            .filter(utils_1.isNotUndefined)
            .filter(v => !ignores.some(i => (0, databaseUtils_1.relationRefSame)(i, (0, databaseUtils_1.relationToRef)(v.relation))))
            .map(violation => {
            const { extra, ...relation } = violation.relation;
            return {
                ruleId,
                ruleName,
                ruleLevel: conf.level,
                message: `Relation ${relationName(violation.relation)} link attributes different types: ${violation.misalignedTypes.map(formatMisalignedType).join(', ')}`,
                entity: (0, databaseUtils_1.relationLinkToEntityRef)(violation.relation.src),
                attribute: violation.relation.src.attrs[0],
                extra: { relation, misalignedTypes: violation.misalignedTypes }
            };
        });
    }
};
const relationName = (r) => r.name || (0, databaseUtils_1.relationToId)(r);
const formatMisalignedType = (t) => `${(0, databaseUtils_1.attributeRefToId)(t.src)}: ${t.srcType} != ${(0, databaseUtils_1.attributeRefToId)(t.ref)}: ${t.refType}`;
// same as frontend/src/PagesComponents/Organization_/Project_/Views/Modals/SchemaAnalysis/InconsistentTypeOnRelations.elm
function getMisalignedRelation(relation, entities) {
    const src = entities[(0, databaseUtils_1.entityRefToId)(relation.src)];
    const ref = entities[(0, databaseUtils_1.entityRefToId)(relation.ref)];
    if (!src && !ref) {
        return undefined;
    }
    const attrs = (0, utils_1.zip)(relation.src.attrs, relation.ref.attrs).map(([srcAttr, refAttr]) => ({
        src: srcAttr,
        srcAttr: (0, databaseUtils_1.getAttribute)(src.attrs, srcAttr),
        ref: refAttr,
        refAttr: (0, databaseUtils_1.getAttribute)(ref.attrs, refAttr),
    }));
    if (attrs.some(a => !a.srcAttr || !a.refAttr)) {
        return undefined;
    }
    const misalignedTypes = attrs.flatMap(attr => attr.srcAttr && attr.refAttr && attr.srcAttr.type !== attr.refAttr.type ? [{
            src: { ...(0, databaseUtils_1.relationLinkToEntityRef)(relation.src), attribute: attr.src },
            srcType: attr.srcAttr?.type,
            ref: { ...(0, databaseUtils_1.relationLinkToEntityRef)(relation.ref), attribute: attr.ref },
            refType: attr.refAttr?.type,
        }] : []);
    return misalignedTypes.length > 0 ? { relation, misalignedTypes } : undefined;
}
//# sourceMappingURL=relationMisaligned.js.map